import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { PERMISSION_CODES, WORKSPACE } from "constants/AuthConstant";
import WorkspaceService from "services/WorkspaceService";

export const getMyPermission = createAsyncThunk(
  "permission/getMyPermission",
  async (data, { rejectWithValue }) => {
    try {
      const response = await WorkspaceService.getMyPermission();
      if (response.data.permissionCodes)
        localStorage.setItem(PERMISSION_CODES, response.data.permissionCodes);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
  {
    condition: (arg, { getState }) => arg?.force === true || !getState().permissionApi.permissionLoading,
  },
);

export const switchWorkspace = createAsyncThunk(
  "permission/switchWorkspace",
  async (data, { rejectWithValue }) => {
    try {
      const { workspace, onSuccess } = data;
      const response = await WorkspaceService.switchWorkspace(workspace);

      if (response.data) {
        localStorage.setItem(WORKSPACE, workspace);
        if (onSuccess) onSuccess(response);
        return response.data;
      } else {
        return rejectWithValue(response.message?.replace("Firebase: ", ""));
      }
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

const initialState = {
  loading: false,
  permissionLoading: false,
  permissionRequestId: null,
  permissions: [],
  workspace: localStorage.getItem(WORKSPACE) || null,
};

export const workspaceSlice = createSlice({
  name: "workspaceSlice",
  initialState,
  reducers: {
    showLoading: (state) => {
      state.loading = true;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getMyPermission.pending, (state, action) => {
        state.loading = true;
        state.permissionLoading = true;
        state.permissionRequestId = action.meta.requestId;
      })
      .addCase(getMyPermission.fulfilled, (state, action) => {
        if (state.permissionRequestId !== action.meta.requestId) return;

        state.loading = false;
        state.permissionLoading = false;
        state.permissions = action.payload;
      })
      .addCase(getMyPermission.rejected, (state, action) => {
        if (state.permissionRequestId !== action.meta.requestId) return;

        state.loading = false;
        state.permissionLoading = false;
        state.permissions = { permissionCodes: [] };
      })

      .addCase(switchWorkspace.pending, (state) => {
        state.loading = true;
      })
      .addCase(switchWorkspace.fulfilled, (state, action) => {
        state.loading = false;
        state.workspace = action.meta.arg?.workspace ?? state.workspace;
        state.permissions = [];
      })
      .addCase(switchWorkspace.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { showLoading } = workspaceSlice.actions;

export default workspaceSlice.reducer;